import {observer} from 'mobx-react-lite';

import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';

import CustomerQuoteFormStore from './FormStore';

import CustomerFields from './FormFields/CustomerFields';
import QuoteInputFields from './FormFields/QuoteInputFields';

export default observer(({open, close}: {open: boolean; close: (changed?: boolean) => void}) => {
    const customerQuoteFormStore = new CustomerQuoteFormStore({open, close});

    return (
        <Dialog open={open} onClose={() => close()} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Create Customer & Quote</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter name, email and phone number of the new customer & quote details
                </DialogContentText>

                <CustomerFields state={customerQuoteFormStore} />

                <QuoteInputFields state={customerQuoteFormStore} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => close()} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => customerQuoteFormStore.saveForm()} color="primary">
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
});
